module.exports = __webpack_public_path__ + "static/media/status-pending.6bc79be8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/status-pending.svg
// module id = 226
// module chunks = 0